module.exports = __webpack_public_path__ + "static/media/head-others.e6661a76.png";